import UserService from '@/services/user.service.js'
const actions = {
async GetUsers({ dispatch }) {
        try {
          const response = await UserService.GetUsers()
            const data = response.payload.responseData || response.payload || response
            console.log('user data', data)
            return data
        } catch (error) {
          dispatch(
            'notification/showError',
            error.message || 'Failed to load accounting years',
            { root: true }
          )
          throw error
        }
      }
}
export default {
   namespaced: true,
   actions
}
